import React from 'react';
import { Lock, Crown } from 'lucide-react';

/**
 * Full-panel gate for a tab whose content requires a paid plan. When locked,
 * renders an upgrade CTA instead of `children` — the backend hard-locks these
 * routes too, so there's no reason to mount a component that will just 403.
 */
const LockedFeature = ({ locked, title, description, onUpgrade, children }) => {
  if (!locked) return children;

  return (
    <div className="w-full h-full flex items-center justify-center p-6">
      <div
        className="max-w-md w-full rounded-2xl p-8 text-center"
        style={{
          backgroundColor: 'rgba(251,191,36,0.06)',
          border: '1px solid rgba(251,191,36,0.18)',
        }}
      >
        <div
          className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4"
          style={{ backgroundColor: 'rgba(251,191,36,0.14)', color: '#f59e0b' }}
        >
          <Lock className="w-5 h-5" strokeWidth={2} />
        </div>
        <h3 className="text-lg font-semibold mb-2" style={{ color: 'var(--text-primary)' }}>
          {title}
        </h3>
        {description && (
          <p className="text-sm mb-6" style={{ color: 'var(--text-tertiary)' }}>
            {description}
          </p>
        )}
        <button
          onClick={onUpgrade}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200"
          style={{ backgroundColor: '#f59e0b', color: '#1a1a1a' }}
          onMouseOver={(e) => { e.currentTarget.style.opacity = '0.9'; }}
          onMouseOut={(e) => { e.currentTarget.style.opacity = '1'; }}
        >
          <Crown className="w-4 h-4" strokeWidth={2} />
          Upgrade plan
        </button>
      </div>
    </div>
  );
};

export default LockedFeature;
